import { rupiah } from "../../lib/api";

export function ShipmentItemsTable({ items, total, testid }) {
  return (
    <table className="w-full text-xs" data-testid={testid}>
      <thead><tr className="text-muted-foreground border-b border-border"><th className="text-left py-1 font-medium">Barang / Alat</th><th className="text-right py-1 font-medium">Jml</th><th className="text-right py-1 font-medium">Harga</th><th className="text-right py-1 font-medium">Subtotal</th></tr></thead>
      <tbody>
        {items.map((it, i) => (
          <tr key={i} className="border-b border-border/50">
            <td className="py-1 font-medium">{it.name}</td>
            <td className="py-1 text-right font-mono">{it.qty}</td>
            <td className="py-1 text-right font-mono text-muted-foreground">{it.price ? rupiah(it.price) : "-"}</td>
            <td className="py-1 text-right font-mono">{it.price ? rupiah(it.price * it.qty) : "-"}</td>
          </tr>
        ))}
      </tbody>
      <tfoot><tr><td colSpan={3} className="py-1 text-right font-semibold">Total</td><td className="py-1 text-right font-mono font-bold">{rupiah(total || 0)}</td></tr></tfoot>
    </table>
  );
}
